import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

import { ApiService, Keyway } from '@overtur-monorepo/keying-shared'
import { HierarchyConfig } from '../../configuration/keying.hierarchy.environment.config'

@Injectable({
  providedIn: 'root',
})
export class KeywayService {
  keyways = new BehaviorSubject<Keyway[]>([])
  keyways$ = this.keyways.asObservable()

  constructor(private api: ApiService, private config: HierarchyConfig) {}

  getKeyways(keywayFamilyId: number, keywayId: number): Observable<Keyway> {
    const serviceEndpoint = `KeywayFamilies/${keywayFamilyId}/keyways/${keywayId}`
    return this.api.get<Keyway>(this.buildUrl(serviceEndpoint))
  }

  getAllKeyways(keywayFamilyId: number): Observable<Keyway[]> {
    const serviceEndpoint = `KeywayFamilies/${keywayFamilyId}/keyways`
    return this.api.get<Keyway[]>(this.buildUrl(serviceEndpoint))
  }

  setAllKeyways(keyways: Keyway[]) {
    this.keyways.next(keyways)
  }

  private buildUrl(serviceEndpoint: string): string {
    return `${this.config.baseUrl}/${serviceEndpoint}`
  }
}
